import React from 'react';
import { connect } from 'react-redux';
import { actions } from 'react-redux-form/immutable';
import {
  Button,
  Card,
  CardBody,
  CardTitle,
} from 'reactstrap';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Loading } from '../../../loadbar/Loading';
import { LabeledText } from '../../../form/LabeledText';
import { LabeledSelect } from '../../../form/LabeledSelect';
import { LabeledTextArea } from '../../../form/LabeledTextArea';
import {
  clearReference as clearReferenceAc,
  getReference as getReferenceAc,
  createReference as createReferenceAc,
  updateReference as updateReferenceAc,
  getHaves as getHavesAc,
  openEditConfirmation as openEditConfirmationAc,
  cancelEditConfirmation as cancelEditConfirmationAc,
} from '../../../../redux/references/edit/referenceEditActions';
import { referenceEditModel, createInitialForm, formToJson } from './referenceEditModel';
import { LabeledCheckbox } from '../../../form/LabeledCheckbox';
import { HtmlEditor } from '../../../form/HtmlEditor';
import { EditForm } from '../../../form/EditForm';

const model = referenceEditModel.get('name');
const initialValues = referenceEditModel.get('initialValues');

class ReferenceEditPageUnwrapped extends React.Component {
  constructor(props) {
    super(props);
    this.resetForm = this.resetForm.bind(this);
    this.cancel = this.cancel.bind(this);
    this.state = {
      initialized: false,
      isAdd: false,
    };
  }

  componentDidMount() {
    document.title = 'NCEI Hazard Reference Edit';
    const {
      match: { params: { id } },
      getReference, getHaves,
      history,
    } = this.props;
    const isAdd = !id;
    const state = {
      isAdd,
    };
    if (id) {
      getReference({ id, history });
    }
    getHaves({ history });
    this.setState(state);
  }

  componentDidUpdate() {
    const { initialized } = this.state;
    if (!initialized) {
      const {
        fetched, initializeForm, reference,
      } = this.props;
      if (fetched) {
        const form = createInitialForm(reference);
        initializeForm(form);
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({ initialized: true });
      }
    }
  }

  componentWillUnmount() {
    const {
      resetForm, initializeForm, setPristine, clearReference,
    } = this.props;
    clearReference();
    initializeForm(initialValues);
    resetForm();
    setPristine();
  }

  resetForm() {
    const {
      resetForm, setPristine, change, reference,
    } = this.props;
    resetForm();
    // There seems to be a bug in react-redux-form. This needs to be called to set the original data.
    change('', createInitialForm(reference));
    setPristine();
  }

  cancel() {
    const { history } = this.props;
    history.goBack();
  }

  render() {
    const { isAdd, initialized } = this.state;
    const {
      pristine,
      updating,
      haves,
      createReference,
      updateReference,
      match: { params: { id } },
      formData,
      editConfirmationOpen,
      cancelEditConfirmation,
      openEditConfirmation,
      reference,
    } = this.props;
    if (!initialized) {
      return (<Loading />);
    }


    return (
      <div className="haz-results-container haz-page-container">

        <Card className="haz-page-card">
          <CardBody>
            <CardTitle tag="h1" className="haz-page-card-title">{isAdd ? 'Add Reference' : `Edit Reference: ${id}`}</CardTitle>

            <EditForm
              model={model}
              hazardName="Reference"
              saving={updating}
              create={createReference}
              update={updateReference}
              isAdd={isAdd}
              id={id || '-1'}
              formData={formData}
              editConfirmationOpen={editConfirmationOpen}
              handleOpen={form => openEditConfirmation({ formData: formToJson(form) })}
              handleCancel={cancelEditConfirmation}
              original={reference}
            >

              <Card>
                <CardBody>
                  <CardTitle tag="h2">Reference</CardTitle>
                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-md-10']} model=".author" label="Author" readOnly={updating} />
                    <LabeledText formGroupClassName={['col-md-2']} model=".year" label="Year" readOnly={updating} />
                  </div>
                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-md-2']} model=".ok" label="Ok" readOnly={updating} />
                    <LabeledSelect childOptions={haves.toJS()} formGroupClassName={['col-md-10']} parentModel={model} fieldId="have" label="Have and DB Status" readOnly={updating} sorted={false} requiresValue prependId />
                  </div>
                </CardBody>
              </Card>

              <Card>
                <CardBody>
                  <CardTitle tag="h2">Citation</CardTitle>
                  <HtmlEditor model={model} field="citation" readOnly={updating} />
                </CardBody>
              </Card>

              <Card>
                <CardBody>
                  <CardTitle tag="h2">Comments</CardTitle>
                  <LabeledTextArea model=".comments" label="Comments" rows={10} readOnly={updating} />
                </CardBody>
              </Card>

              <Card>
                <CardBody>
                  <CardTitle tag="h2">Visibility</CardTitle>
                  <div className="form-row">
                    <LabeledCheckbox inline model=".publish" label="Publish" />
                  </div>
                </CardBody>
              </Card>

              <div>
                <Button disabled={updating || pristine} type="submit" color="primary" className="ml-5">{isAdd ? 'Create' : 'Update'}</Button>
                <Button disabled={updating || pristine} color="secondary" className="ml-2" onClick={this.resetForm}>Reset</Button>
                <Button disabled={updating} color="secondary" className="ml-2" onClick={this.cancel}>Cancel</Button>
              </div>
            </EditForm>

          </CardBody>
        </Card>

      </div>
    );
  }
}

ReferenceEditPageUnwrapped.propTypes = {
  clearReference: PropTypes.func.isRequired,
  getReference: PropTypes.func.isRequired,
  createReference: PropTypes.func.isRequired,
  updateReference: PropTypes.func.isRequired,
  reference: ImmutablePropTypes.map.isRequired,
  match: PropTypes.shape({ params: PropTypes.shape({ id: PropTypes.number }) }).isRequired,
  fetched: PropTypes.bool.isRequired,
  updating: PropTypes.bool.isRequired,
  resetForm: PropTypes.func.isRequired,
  setPristine: PropTypes.func.isRequired,
  initializeForm: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  history: PropTypes.shape({ goBack: PropTypes.func }).isRequired,
  change: PropTypes.func.isRequired,
  getHaves: PropTypes.func.isRequired,
  haves: ImmutablePropTypes.list.isRequired,
  openEditConfirmation: PropTypes.func.isRequired,
  cancelEditConfirmation: PropTypes.func.isRequired,
  formData: ImmutablePropTypes.map.isRequired,
  editConfirmationOpen: PropTypes.bool.isRequired,
};

const mapStateToProps = (state, props) => {
  const { match: { params: { id } } } = props;
  const isAdd = !id;

  const fetchedCheck = [
    state.getIn(['referenceEditPage', 'fetchedHaves']),
  ];
  if (!isAdd) {
    fetchedCheck.push(state.getIn(['referenceEditPage', 'fetched']));
  }

  return {
    fetched: fetchedCheck.every(v => v),
    reference: state.getIn(['referenceEditPage', 'reference']),
    pristine: state.get('forms')[model].$form.pristine,
    updating: state.getIn(['referenceEditPage', 'updating']),
    haves: state.getIn(['referenceEditPage', 'haves']),
    formData: state.getIn(['referenceEditPage', 'formData']),
    editConfirmationOpen: state.getIn(['referenceEditPage', 'editConfirmationOpen']),
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  clearReference: clearReferenceAc,
  getReference: getReferenceAc,
  createReference: createReferenceAc,
  updateReference: updateReferenceAc,
  resetForm: () => actions.reset(model),
  change: (field, value) => actions.change(`${model}${field}`, value),
  initializeForm: volcanoLocation => actions.load(model, volcanoLocation),
  setPristine: () => actions.setPristine(model),
  getHaves: getHavesAc,
  openEditConfirmation: openEditConfirmationAc,
  cancelEditConfirmation: cancelEditConfirmationAc,
}, dispatch);

export const ReferenceEditPage = connect(mapStateToProps, mapDispatchToProps)(ReferenceEditPageUnwrapped);
